export default __webpack_public_path__ + "static/media/logo_superfin.a36de4a1.png";